import React from 'react';

import { notNullish } from '@paragon/utilities';

import { SelectedItemIdentifier } from '../../../../library/selection/types';
import { TransformationMenuItems } from '../../../../library/transformations/controls/TransformationMenuItems';
import { useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { DeleteMenuItem } from '../shared-menu-items/DeleteMenuItem';

export function WorkLineMenu(props: { guid: string; matchingSelectedItems: SelectedItemIdentifier[] }) {
  const workLines = useAppSelector((state) =>
    props.matchingSelectedItems.map((item) => state.layout.workLines[item.guid]),
  ).filter(notNullish);

  if (workLines.length < props.matchingSelectedItems.length) {
    throw new Error('Unable to find work line(s) for active menu.');
  }

  return (
    <SceneMenuContent>
      <TransformationMenuItems />

      <DeleteMenuItem
        type="workLine"
        item={workLines}
        userVisibleTerm={workLines.length > 1 ? 'Work Lines' : 'Work Line'}
      />
    </SceneMenuContent>
  );
}
